import { encore } from '@saucelabs/sl-util-axios';


export const reportJobIssue = (payload) => (
  encore.post('/api/support_issues', payload)
);
